import create from 'zustand';

export interface IDataUnit {
  '1st_party_fraud': number;
  amount: number;
  anomalies: number;
  cluster: number;
  dispute: boolean;
  dispute_amount: number;
  dispute_count: number;
  dispute_ratio_in_cluster: number;
  disputes_in_cluster: number;
  distance_to_closest_dispute: number;
  distance_to_closest_fraud: number;
  distance_to_embedding_center: number;
  distance_to_last_purchase: number;
  distance_to_persona_center: number;
  fraud_ratio_in_cluster: number;
  location_embedding_x: number;
  location_embedding_y: number;
  location_embedding_z: number;
  mean_distance_to_last_20_transactions: number;
  mean_distance_to_last_30_transactions: number;
  merchant: string;
  predicted_fraud: boolean;
  trans_date: string;
  trans_index: number;

  transaction_history_motifs?: number | null;
  transaction_time_motiifs?: number | null;
  amount_motifs?: number | null;
  merchant_motifs?: number | null;
  network_motifs?: number | null;
  news_sentiment_motifs?: number | null;
}

export interface ISidebarFilter {
  date: {
    type: 'year' | 'month' | 'week';
    value: string;
  };
  displayUnit: '#' | '$';
  sliderValue: number;
}

export interface IState {
  allDataStore: IDataUnit[];
  // eslint-disable-next-line no-unused-vars
  setAllDataStore: (newData: IDataUnit[]) => void;

  sidebarFilterStore: ISidebarFilter;
  // eslint-disable-next-line no-unused-vars
  setSidebarFilterStore: (newSidebarFilter: ISidebarFilter) => void;
}

export const useStore = create<IState>((set) => ({
  allDataStore: [],
  setAllDataStore: (newData: IDataUnit[]) =>
    set({
      allDataStore: [...newData],
    }),

  sidebarFilterStore: {
    date: {
      type: 'year',
      value: '01/01/2021',
    },
    displayUnit: '#',
    sliderValue: 80,
  },
  setSidebarFilterStore: (newSidebarFilter: ISidebarFilter) =>
    set({
      sidebarFilterStore: {
        ...newSidebarFilter,
      },
    }),
}));
